"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CollaborationConsumer = exports.CollaborationProvider = void 0;

var _react = _interopRequireDefault(require("react")),
    NOOP = function NOOP() {
  return {};
},
    defaultValue = {
  showCollaborationModal: void 0,
  hideCollaborationModal: void 0,
  showShareModal: void 0,
  hideShareModal: void 0,
  fetchCollaborationData: NOOP,
  resourceName: void 0,
  members: void 0
},
    CollaborationContext = _react["default"].createContext(defaultValue),
    CollaborationProvider = CollaborationContext.Provider;

exports.CollaborationProvider = CollaborationProvider;
var CollaborationConsumer = CollaborationContext.Consumer;
exports.CollaborationConsumer = CollaborationConsumer;